import type {
  LimitOrderRequest,
  LimitOrderRequestDto,
  MarketOrderRequest,
  MarketOrderRequestDto,
  TpSlOrder,
  TpSlOrderDto,
  TpSlOrderRequest,
  TpSlOrderRequestDto,
} from '@/lib/api/order/types';

export function toMarketOrderDto(body: MarketOrderRequest): MarketOrderRequestDto {
  return {
    e: body.eventId,
    o: body.eventOutcomeId,
    ba: body.baseAssetId,
    qa: body.quoteAssetId,
    s: body.side,
    am: body.amount, // BUY orders: trade volume in quote currency
    q: body.shares, // SELL orders: size in base currency
  };
}

export function toLimitOrderDto(body: LimitOrderRequest): LimitOrderRequestDto {
  return {
    e: body.eventId,
    o: body.eventOutcomeId,
    ba: body.baseAssetId,
    qa: body.quoteAssetId,
    s: body.side,
    p: body.price,
    q: body.quantity,
    // Include x if expireAt is explicitly provided (string or null), skip if undefined
    ...(body.expireAt !== undefined ? { x: body.expireAt } : {}),
  };
}

/**
 * Map TP/SL order DTO to model
 */
export function mapTpSlOrder(dto: TpSlOrderDto): TpSlOrder {
  return {
    id: dto.i,
    quantity: dto.q,
    takeProfitPrice: dto.tpp,
    stopLossPrice: dto.slp,
  };
}

/**
 * Map TP/SL order request to DTO
 */
export function toTpSlOrderDto(body: TpSlOrderRequest): TpSlOrderRequestDto {
  return {
    e: body.eventId,
    o: body.eventOutcomeId,
    ba: body.baseAssetId,
    oa: body.orderAssetId,
    qa: body.quoteAssetId,
    i: body.intent,
    s: body.side,
    q: body.quantity,
    t: body.takeProfitPrice,
    l: body.stopLossPrice,
  };
}
